module.exports = __webpack_public_path__ + "static/media/ada.bd5362dc.gif";